import h from './handleChange';

export const handleChange = h;